import useIdleTimer from "../../utils/IdleTimer";
import SessionWarningModal from "../SessionWarningModal/SessionWarningModal";

const IdleTimerWrapper = () => {
  const { showWarning, countdown, handleStayLoggedIn, isLoggingOut } =
    useIdleTimer();

  return (
    <SessionWarningModal
      open={showWarning}
      countdown={countdown}
      onStayLoggedIn={handleStayLoggedIn}
      isLoggingOut={isLoggingOut}
    />
  );
};

export default IdleTimerWrapper;
